import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=1ee871a1&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=1ee871a1&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee871a1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ee871a1')) {
      api.createRecord('1ee871a1', component.options)
    } else {
      api.reload('1ee871a1', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=1ee871a1&scoped=true", function () {
      api.rerender('1ee871a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/competition/detail.vue"
export default component.exports